import { formatAmount } from '../lib/format';
import type { Currency, Summary } from '../lib/types';

// Combined balance card — both currencies + USD-equivalent total in one card.
export default function BalanceCard({ summary }: { summary: Summary }) {
  const rate = summary.latest_rate_syp_per_usd;
  const totalUsd = rate
    ? summary.balances.USD + summary.balances.SYP / rate
    : null;
  const hasAny = summary.balances.USD !== 0 || summary.balances.SYP !== 0;

  return (
    <div className="card">
      {(['SYP', 'USD'] as Currency[]).map((cur) => (
        <div className="balance-row" key={cur}>
          <div>
            <div className="balance-cur">{cur} balance</div>
            <div className="balance-amount">{formatAmount(summary.balances[cur], cur)}</div>
          </div>
          <div className="balance-spent">
            spent this month<br />
            <strong>{formatAmount(summary.month_spend[cur], cur)}</strong>
          </div>
        </div>
      ))}
      {totalUsd != null && hasAny && (
        <div className="balance-total">
          ≈ <strong>{formatAmount(totalUsd, 'USD')}</strong> total
          {rate ? ` · ${rate.toLocaleString('en-US', { maximumFractionDigits: 0 })} SYP/USD` : ''}
        </div>
      )}
    </div>
  );
}
